import { yupResolver } from "@hookform/resolvers/yup";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  fetchListMemberAddress,
  insertMemberAddress,
  updateMemberAddress,
} from "../../../../api/memberAddress";
import { failAlert, successAlert } from "../../../../common/alert";
import PostCode from "../../../../common/postcode";
import { AddressSchema } from "../../../../common/util/addressYup";
import KakaoMap from "../../../map/Maptainer";
import * as New from "./MyAddress-new-styles";

const NewMyAddress = (props) => {
  const router = useRouter();
  // api 통신 데이터
  const [myAddress, setMyAddress] = useState();
  const [myAddressCount, setMyAddressCount] = useState(0);
  const { register, handleSubmit, formState, reset, watch } = useForm({
    resolver: yupResolver(AddressSchema),
  });
  const [mapInputs, setMapInputs] = useState({
    addressGps: {
      mapx: "",
      mapy: "",
    },
  });
  const [pickAddress, setPickAddress] = useState({
    address: "",
  });
  const [postOpen, setPostOpen] = useState(false);

  // 우편번호 검색
  const handlePostModal = () => {
    setPostOpen((prev) => !prev);
  };

  const onCompleteAddressCode = (postcode) => {
    setPickAddress(postcode);
    reset({
      zipcode: postcode.zonecode,
      doro_addr: postcode.roadAddress
        ? postcode.roadAddress
        : postcode.autoRoadAddress,
      base_addr: postcode.jibunAddress
        ? postcode.jibunAddress
        : postcode.autoJibunAddress,
    });
    setPostOpen(false);
  };

  // 배송지 등록
  const createAddress = async (data) => {
    const body = {
      modes: "InsertSet",
      addr_name: data.addr_name,
      zipcode: data.zipcode,
      doro_addr: data.doro_addr,
      base_addr: data.base_addr,
      detail_addr: data.detail_addr,
      mapx: mapInputs.addressGps?.mapx,
      mapy: mapInputs.addressGps?.mapy,
    };
    const res = await insertMemberAddress(body);
    if (res?.code === "0000") {
      successAlert("등록 되었습니다.");
      props.setIsOpen(false);
      props.fetchAddressList();
    } else {
      failAlert(res?.data?.Msg);
    }
  };

  // 배송지 수정
  const updateAddress = async (data) => {
    const body = {
      modes: "UpdateSet",
      acode: props.editAddress.acode,
      addr_name: data.addr_name,
      zipcode: data.zipcode,
      doro_addr: data.doro_addr,
      base_addr: data.base_addr,
      detail_addr: data.detail_addr,
      mapx: mapInputs.addressGps?.mapx || data.mapx,
      mapy: mapInputs.addressGps?.mapy || data.mapy,
    };

    const res = await updateMemberAddress(body);
    if (res.code === "0000") {
      successAlert("수정되었습니다");
      props.setIsEdit(false);
      props.setIsOpen(false);
      props.fetchAddressList();
    }
  };

  const backToList = () => {
    props.setIsOpen(false);
    props.setIsEdit(false);
    reset();
  };

  useEffect(() => {
    if (props.isEdit === true) {
      reset({
        addr_name: props.editAddress.name,
        ...props.editAddress,
      });
    }
  }, []);

  return (
    <>
      <New.Header>
        <i className="fi-rs-arrow-left" onClick={backToList} />
        <h4>{props.isEdit ? "배송지 수정" : "배송지 등록"}</h4>
      </New.Header>
      <New.ContentWrapper>
        <New.AddressBox>
          <New.AddressContent>
            <form
              onSubmit={handleSubmit((data) =>
                props.isEdit ? updateAddress(data) : createAddress(data)
              )}
            >
              <New.ContentRow className="address-info">
                <New.ContentCol>
                  <h6>배송지 이름 : </h6>
                  <input type={"text"} {...register("addr_name")} />
                </New.ContentCol>
                <New.ContentCol>
                  <h6>우편번호</h6>
                  <input
                    className="zipcode"
                    type={"text"}
                    readOnly
                    defaultValue={pickAddress.zonecode}
                    {...register("zipcode")}
                  />
                  <div className="btn" onClick={handlePostModal}>
                    주소 검색
                  </div>
                </New.ContentCol>
                <New.ContentCol>
                  <h6>도로명 주소 : </h6>
                  <input
                    type={"text"}
                    readOnly
                    defaultValue={
                      pickAddress.roadAddress
                        ? pickAddress.roadAddress
                        : pickAddress.autoRoadAddress
                    }
                    {...register("doro_addr")}
                  />
                </New.ContentCol>
                <New.ContentCol>
                  <h6>지번 주소</h6>
                  <input
                    type={"text"}
                    readOnly
                    defaultValue={
                      pickAddress.jibunAddress
                        ? pickAddress.jibunAddress
                        : pickAddress.autoJibunAddress
                    }
                    {...register("base_addr")}
                  />
                </New.ContentCol>
                <New.ContentCol>
                  <h6>상세 주소</h6>
                  <input
                    type={"text"}
                    placeholder="상세주소 입력"
                    {...register("detail_addr")}
                  />
                </New.ContentCol>
                <New.ContentCol className="address-btn">
                  <button className="btn-select" type="submit">
                    {props.isEdit ? "수정" : "등록"}
                  </button>
                  <div className="basic-btns">
                    {props.isEdit ? (
                      <button
                        className="btn "
                        type="button"
                        onClick={() => {
                          props.deleteAddress(props.editAddress?.acode);
                          props.setIsEdit(false);
                          props.setIsOpen(false);
                        }}
                      >
                        삭제
                      </button>
                    ) : (
                      <></>
                    )}
                  </div>
                </New.ContentCol>
              </New.ContentRow>
            </form>
          </New.AddressContent>
        </New.AddressBox>
      </New.ContentWrapper>
      {postOpen && (
        <PostCode
          onClickHandleModal={handlePostModal}
          onCompletePostCode={onCompleteAddressCode}
          isCheckout={props.isCheckout}
        />
      )}
      <div style={{ diplay: "none" }}>
        <KakaoMap
          address={pickAddress.address}
          setUserInputs={setMapInputs}
          userinputs={mapInputs}
        />
      </div>
    </>
  );
};
export default NewMyAddress;
